import Seo from "../components/Seo";
import { contactLinks } from "../content";
import { breadcrumbSchema } from "../lib/structuredData";

function ContactPage() {
  return (
    <section id="contact">
      <Seo
        description="Get in touch with Robert Doe about research collaborations, internship opportunities, web security, ML-driven defenses, privacy, HCI, or EdTech for Africa."
        jsonLd={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])}
        path="/contact"
        title="Contact - Robert Doe"
      />
      <div className="contact-inner reveal">
        <span className="contact-tag">09 &middot; Get in Touch</span>
        <h1 className="contact-title">
          Let&apos;s Connect
          <br />
          &amp; Collaborate.
        </h1>
        <p className="contact-sub">
          Open to research collaborations, internship opportunities, and conversations
          around web security, ML-driven defenses, privacy, HCI, or EdTech for Africa.
          Let&apos;s build something meaningful together.
        </p>
        <div className="contact-links">
          {contactLinks.map((link) => {
            const isExternal = link.href.startsWith("http");
            return (
              <a
                className="contact-link"
                href={link.href}
                key={link.label}
                rel={isExternal ? "noreferrer" : undefined}
                target={isExternal ? "_blank" : undefined}
              >
                {link.prefix} {link.label}
              </a>
            );
          })}
        </div>
        <div className="contact-email">
          <a className="__cf_email__" href="mailto:robertdoe009@gmail.com">
            robertdoe009@gmail.com
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
